import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
  Typography,
  Box,
  TablePagination,
  Grid,
  Stack,
} from "@mui/material";
import { motion } from "framer-motion";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import check from "../../../Components/Assets/images/checkimg.jpg";
import wrong from "../../../Components/Assets/images/wrongimg.jpg";
import EditIcon from "@mui/icons-material/Edit";
import configServ from "../../../services/config";
import debounce from "lodash.debounce";
import { useCallback } from "react";

// import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { useRef } from "react";
import CardHeadMenu from "../../../Components/Card/CardHeadMenu/CardHeadMenu";
const PaymentLog = () => {
  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);

  const [isCreate, setIsCreate] = useState(false);
  const [getwayData, setGetwayData] = useState([]);
  const [loading, SetLoading] = useState(true);
  const [searchBy, setSearchBy] = useState("gateway");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchPaymentlogs = async () => {
    try {
      SetLoading(true);
      const payload = {
        company_id: company_id,
        search_by: searchBy,
        search,
        page: page + 1,
        per_page: perPage,
      };
      const res = await configServ.getAllPaymentLogsByCompany(payload);
      if (res.status) {
        setGetwayData(res.data);
        setTotal(res.total);
      }
    } catch (error) {
      console.error("Failed to fetch getways", error);
    } finally {
      SetLoading(false);
    }
  };

  const firstSearchLoad = useRef(true); // to prevent double fetch

  useEffect(() => {
    if (firstSearchLoad.current) {
      firstSearchLoad.current = false;
      return; // skip first auto-fetch here
    }

    setPage(0); // ✅ reset page if search/searchBy changes
  }, [search, searchBy]);

  const debouncedFetch = useCallback(
    debounce(() => {
      fetchPaymentlogs();
    }, 500),
    [search, searchBy, page, perPage]
  );

  useEffect(() => {
    debouncedFetch();
    return debouncedFetch.cancel;
  }, [search, searchBy, page, perPage]);

  return (
    <>
    <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Payment Logs"}
        // handlePopup={handlePopup}
        // isEdit={isEdit}
        // create={isCreate}
        // showCreate={Boolean(is_super || is_admin || permissions?.includes(25))}
        showCreate={false}
      />
    
    <Box sx={{ width: "100%" }}>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Grid item xs={12} md="auto">
            <Typography variant="h6">Total Geteways: {total}</Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl size="small" fullWidth>
                  <InputLabel>Search By</InputLabel>
                  <Select
                    value={searchBy}
                    onChange={(e) => setSearchBy(e.target.value)}
                    label="Search By"
                  >
                    <MenuItem value="gateway">Getway Name</MenuItem>
                    <MenuItem value="order_id">Order Id</MenuItem>
                    <MenuItem value="customer_name">Customer Name</MenuItem>
                    <MenuItem value="status">Status</MenuItem>

                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  fullWidth
                  InputProps={{
                    endAdornment: search && (
                      <IconButton
                        size="small"
                        onClick={() => setSearch("")}
                        edge="end"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </motion.div>

      <Box sx={{ display: { xs: "none", md: "block" } }}>
        {/* Your existing Paper with Table here */}
        <Paper elevation={3}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#2196f3" }}>
                  {[
                    "S.No.",
                    "Gatway Name",
                    "Customer Name",
                    "Order Id",
                    "Amount",
                    "Status",
                  ].map((header) => (
                    <TableCell
                      key={header}
                      sx={{ color: "white", fontWeight: "bold" }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : getwayData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      <Typography variant="body2" sx={{ py: 2 }}>
                        No Payment Log found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  getwayData.map((getway, index) => (
                    <TableRow key={getway.id}>
                      <TableCell>{page * perPage + index + 1}</TableCell>
                      <TableCell>{getway.gateway}</TableCell>
                      <TableCell>{getway.customer_name}</TableCell>
                      <TableCell>{getway.order_id}</TableCell>
                      <TableCell>{getway.amount}</TableCell>
                      <TableCell>{getway.status}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={total}
            rowsPerPage={perPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : getwayData.length === 0 ? (
          <Typography variant="body2" align="center" py={2}>
            No coupons found.
          </Typography>
        ) : (
          getwayData.map((getway, index) => (
            <Paper key={getway.id} elevation={2} sx={{ mb: 2, p: 2, mx: 1 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                {page * perPage + index + 1}. {getway.gateway}
              </Typography>
              <Typography variant="body2">
                Customer Name: {getway.customer_name}
              </Typography>
              <Typography variant="body2">
                Order Id : {getway.order_id}
              </Typography>
              <Typography variant="body2">
                Amount: {getway.amount}
              </Typography>
              <Typography variant="body2">
                Status: {getway.status}
              </Typography>
              
            </Paper>
          ))
        )}

        <TablePagination
          component="div"
          count={total}
          rowsPerPage={perPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </Box>
    </>
  );
};

export default PaymentLog;
